/*
 * Copyright 2024 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { NotificationSettings } from './types';

/** @public */
export const isNotificationsEnabledFor = (
  settings: NotificationSettings,
  channelId: string,
  originId: string,
  topicId: string | null,
) => {
  const channel = settings.channels.find(c => c.id === channelId);
  if (!channel) {
    return true;
  }

  const origin = channel.origins.find(o => o.id === originId);
  if (!origin) {
    return true;
  }
  if (topicId === null) {
    return origin.enabled;
  }
  const topic = origin.topics?.find(t => t.id === topicId);
  if (!topic) {
    return origin.enabled;
  }
  return topic.enabled;
};
